import { tns } from 'tiny-slider/src/tiny-slider';
import BaseComponent from 'foundation/base-component';

class PlayerCarouselComponent extends BaseComponent {
    constructor(...args) {
        super(...args);
        this.gallery = null;

        this.init();
    }

    static getRequiredRefs() {
        return ['slides'];
    }

    init() {
        this.gallery = tns({
            container: this.refs.slides,
            autoWidth: true,
            loop: false,
            nav: false,
            controls: false,
            touch: false,
            responsive: {
                579: {
                    slideBy: 2
                },
                1023: {
                    slideBy: 3
                }
            }
        });

        if (Array.isArray(this.refs.prevBtn)) {
            this.refs.prevBtn.forEach((x) => {
                this.addListener(x, 'click', this.onClickPrevBtn);
            });
        }
        if (Array.isArray(this.refs.nextBtn)) {
            this.refs.nextBtn.forEach((x) => {
                this.addListener(x, 'click', this.onClickNextBtn);
            });
        }
    }

    onClickPrevBtn = (event) => {
        event.preventDefault();
        this.gallery.goTo('prev');
    }

    onClickNextBtn = (event) => {
        event.preventDefault();
        this.gallery.goTo('next');
    }

    onDestroy() {
        this.gallery.destroy();
    }
}

export default PlayerCarouselComponent;
